import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UxService } from '~/app/core/services';
import { RoleService } from '../../core/services';
import { User } from '../models';
import { SendItApiBase } from './sendit-api.base';

@Injectable()
export class UserService extends SendItApiBase<User> {

  constructor(http: HttpClient, roleService: RoleService, uxService: UxService) {
    super('users', http, roleService, uxService);
  }
}
